import React, { useEffect, useState } from "react";
import "./styles.scss";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Flex, Popconfirm } from "antd";
import { Tag } from "..";
import TagWidgetCard from "../tagWidgetCard";
import {
  deleteWidgetNews,
  getNewsByTag,
  getNewsByWidget,
} from "../../containers/news/service/news.service";
import { Store } from "react-notifications-component";

const TagWidgetGroupCard = (props) => {
  const [newsList, setNewsList] = useState([]);
  const [selectedNews, setSelectNews] = useState([]);
  const [selectList, setSelectList] = useState([]);

  const onClickCancel = (e) => {
    console.log(e);
  };

  //delect by selecting news
  const onClickDelete = async () => {
    try {
      if (selectList.length === 0) {
        alert("Please select news to delete");
        return;
      } else {
        for (const item of newsList) {
          if (selectList.includes(item.news_id)) {
            await handleDeleteTag(item);
          }
        }
        // await props.fetchData();
      }
    } catch (error) {
      console.log("Error Deleting News : ", error);
    }
  };

  const handleDeleteTag = async (item) => {
    try {
      if (item?.news_id) {
        const deleteResponse = await deleteWidgetNews(item?.news_id);
        console.log("Delete Response : ", deleteResponse);
        if (deleteResponse?.data) {
          fetchNews(props.tagId);
          Store.addNotification({
            title: "Success!",
            message: "News Deleted Successfully",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
          // props.Refresh(true);
        }
      }
    } catch (error) {
      console.log("Error Deleting News : ", error);
      Store.addNotification({
        title: "Error!",
        message: "An error occurred while deleting the News",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
    }
  };

  useEffect(() => {
    setSelectList([]);
    if (props.tagId) {
      fetchNews(props.tagId);
    }
  }, [props.tagId]);

  const fetchNews = async (widget_id) => {
    console.log("Fetching news for tag_id:", widget_id);
    const response = await getNewsByWidget(widget_id);
    console.log("News Response:", response);
    if (response?.data?.news) {
      setNewsList(response?.data?.news);
    }
  };

  return (
    <>
      <div
        className={`hne-widget-group-card-wrapper ${
          props.isSelect ? "active" : ""
        }`}
      >
        <div className="wgc-heading-wrapper">
          <div className="d-flex flex-row" style={{ gap: "10px" }}>
            <div className="wgc-title-en">#{props.titleSi}</div>
            <div className="wgc-title-id">{props.titleId}</div>
          </div>
          <div className="wgc-buttons-wrapper">
            <div className="wgc-edit" onClick={props.onClickEdit}>
              {props.edit}
            </div>
            <div className="wgc-delete">
              <Popconfirm
                placement="topLeft"
                title="Delete the Widget"
                description="Are you sure to delete this Widget?"
                onConfirm={props.onClickRemove}
                onCancel={onClickCancel}
                okText="Yes"
                cancelText="No"
              >
                {props.delete}
                {/* <span className="remove-button"> {GetIconByName("cross")}</span>{" "} */}
              </Popconfirm>
            </div>
          </div>
        </div>

        <div className="wgc-body-wrapper">
          {Array.isArray(newsList) && newsList.length === 0 && (
            <div className="error-message">No News Found</div>
          )}
          {Array.isArray(newsList) &&
            newsList.length > 0 &&
            newsList.map((item) => {
              return (
                <div className="d-flex" key={item.news_id}>
                  <TagWidgetCard
                    isSelect={selectList.includes(item.news_id)}
                    logo={item?.images?.[0]?.url}
                    titleSi={item?.title?.si}
                    closeDate={item?.created_at}
                    views={item?.views}
                    onClickSelect={() => {
                      if (!selectList.includes(item?.news_id)) {
                        setSelectList([...selectList, item?.news_id]);
                      } else {
                        setSelectList(
                          selectList.filter((news) => news !== item?.news_id)
                        );
                      }
                    }}
                    delete={"Delete"}
                    onClickDelete={() => {
                      if (selectList.includes(item?.news_id)) {
                        onClickDelete();
                      }
                    }}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default withRouter(TagWidgetGroupCard);
